/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDevice = /* GraphQL */ `
  query GetDevice($id: ID!) {
    getDevice(id: $id) {
      id
      serial
      type
      version
      owner
      name
      privateAudio
      shareLink
      shareBird
      shareMarine
      hideOnMap
      collectSoundscape
      createdAt
      updatedAt
      lat
      lon
      tzOffsetMinutes
      tz
      smsPhone1
      smsPhone2
      smsTimeStart
      smsTimeStop
      smsPause
      newBirdAlert
      __typename
    }
  }
`;
export const listDevices = /* GraphQL */ `
  query ListDevices(
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDevices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        type
        version
        owner
        name
        privateAudio
        shareLink
        shareBird
        shareMarine
        hideOnMap
        collectSoundscape
        createdAt
        updatedAt
        lat
        lon
        tzOffsetMinutes
        tz
        smsPhone1
        smsPhone2
        smsTimeStart
        smsTimeStop
        smsPause
        newBirdAlert
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const haikuboxBySerial = /* GraphQL */ `
  query HaikuboxBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModeldeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    haikuboxBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        type
        version
        owner
        name
        privateAudio
        shareLink
        shareBird
        shareMarine
        hideOnMap
        collectSoundscape
        createdAt
        updatedAt
        lat
        lon
        tzOffsetMinutes
        tz
        smsPhone1
        smsPhone2
        smsTimeStart
        smsTimeStop
        smsPause
        newBirdAlert
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const haikuboxByType = /* GraphQL */ `
  query HaikuboxByType(
    $type: String!
    $sortDirection: ModelSortDirection
    $filter: ModeldeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    haikuboxByType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        type
        version
        owner
        name
        privateAudio
        shareLink
        shareBird
        shareMarine
        hideOnMap
        collectSoundscape
        createdAt
        updatedAt
        lat
        lon
        tzOffsetMinutes
        tz
        smsPhone1
        smsPhone2
        smsTimeStart
        smsTimeStop
        smsPause
        newBirdAlert
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const haikuboxByOwner = /* GraphQL */ `
  query HaikuboxByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModeldeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    haikuboxByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        type
        version
        owner
        name
        privateAudio
        shareLink
        shareBird
        shareMarine
        hideOnMap
        collectSoundscape
        createdAt
        updatedAt
        lat
        lon
        tzOffsetMinutes
        tz
        smsPhone1
        smsPhone2
        smsTimeStart
        smsTimeStop
        smsPause
        newBirdAlert
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeviceHistory = /* GraphQL */ `
  query GetDeviceHistory($id: ID!) {
    getDeviceHistory(id: $id) {
      id
      serial
      version
      owner
      name
      shareBird
      createDate
      createdAt
      updatedAt
      lat
      lon
      deviceAction
      __typename
    }
  }
`;
export const listDeviceHistories = /* GraphQL */ `
  query ListDeviceHistories(
    $filter: ModelDeviceHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeviceHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        version
        owner
        name
        shareBird
        createDate
        createdAt
        updatedAt
        lat
        lon
        deviceAction
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deviceHistoryBySerial = /* GraphQL */ `
  query DeviceHistoryBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModeldeviceHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deviceHistoryBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        version
        owner
        name
        shareBird
        createDate
        createdAt
        updatedAt
        lat
        lon
        deviceAction
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deviceHistoryByOwner = /* GraphQL */ `
  query DeviceHistoryByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModeldeviceHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deviceHistoryByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        version
        owner
        name
        shareBird
        createDate
        createdAt
        updatedAt
        lat
        lon
        deviceAction
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deviceHistoryByDate = /* GraphQL */ `
  query DeviceHistoryByDate(
    $createDate: AWSDate!
    $sortDirection: ModelSortDirection
    $filter: ModeldeviceHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deviceHistoryByDate(
      createDate: $createDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        version
        owner
        name
        shareBird
        createDate
        createdAt
        updatedAt
        lat
        lon
        deviceAction
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHit = /* GraphQL */ `
  query GetHit($id: ID!) {
    getHit(id: $id) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      lat
      lon
      score
      specSum
      version
      detectionArray
      detectionConfidence
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHits = /* GraphQL */ `
  query ListHits(
    $filter: ModelHitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        lat
        lon
        score
        specSum
        version
        detectionArray
        detectionConfidence
        detectionCount
        type
        labeledBy
        label
        human
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hitBySerialByDate = /* GraphQL */ `
  query HitBySerialByDate(
    $serial: String!
    $dt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelhitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hitBySerialByDate(
      serial: $serial
      dt: $dt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        lat
        lon
        score
        specSum
        version
        detectionArray
        detectionConfidence
        detectionCount
        type
        labeledBy
        label
        human
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hitsBySpeciesByDate = /* GraphQL */ `
  query HitsBySpeciesByDate(
    $serial: String!
    $cnDt: ModelhitHitsBySpeciesByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelhitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hitsBySpeciesByDate(
      serial: $serial
      cnDt: $cnDt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        lat
        lon
        score
        specSum
        version
        detectionArray
        detectionConfidence
        detectionCount
        type
        labeledBy
        label
        human
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHitNotInGrid = /* GraphQL */ `
  query GetHitNotInGrid($id: ID!) {
    getHitNotInGrid(id: $id) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      latitude
      longitude
      score
      specSum
      version
      detectionArrayF
      detectionConfidenceF
      detectionArrayUf
      detectionConfidenceUf
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHitNotInGrids = /* GraphQL */ `
  query ListHitNotInGrids(
    $filter: ModelHitNotInGridFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHitNotInGrids(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        latitude
        longitude
        score
        specSum
        version
        detectionArrayF
        detectionConfidenceF
        detectionArrayUf
        detectionConfidenceUf
        detectionCount
        type
        labeledBy
        label
        human
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hitNotInGridBySpeciesByDate = /* GraphQL */ `
  query HitNotInGridBySpeciesByDate(
    $spCode: String!
    $dt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelhitNotInGridFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hitNotInGridBySpeciesByDate(
      spCode: $spCode
      dt: $dt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        latitude
        longitude
        score
        specSum
        version
        detectionArrayF
        detectionConfidenceF
        detectionArrayUf
        detectionConfidenceUf
        detectionCount
        type
        labeledBy
        label
        human
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeviceState = /* GraphQL */ `
  query GetDeviceState($id: ID!) {
    getDeviceState(id: $id) {
      id
      serial
      type
      lat
      lon
      timezone
      connected
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDeviceStates = /* GraphQL */ `
  query ListDeviceStates(
    $filter: ModelDeviceStateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeviceStates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        type
        lat
        lon
        timezone
        connected
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBootTable = /* GraphQL */ `
  query GetBootTable($id: ID!) {
    getBootTable(id: $id) {
      id
      serial
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBootTables = /* GraphQL */ `
  query ListBootTables(
    $filter: ModelBootTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBootTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bootBySerialByDate = /* GraphQL */ `
  query BootBySerialByDate(
    $serial: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelbootTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bootBySerialByDate(
      serial: $serial
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStatusTable = /* GraphQL */ `
  query GetStatusTable($id: ID!) {
    getStatusTable(id: $id) {
      id
      serial
      cpuTemp
      cpuFreq
      warning
      ramdisk
      signal
      availMem
      pyMem
      gridLength
      nDirect
      nCloud
      freeGB
      lat
      lon
      V
      ovf
      postTime
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStatusTables = /* GraphQL */ `
  query ListStatusTables(
    $filter: ModelStatusTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStatusTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        cpuTemp
        cpuFreq
        warning
        ramdisk
        signal
        availMem
        pyMem
        gridLength
        nDirect
        nCloud
        freeGB
        lat
        lon
        V
        ovf
        postTime
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const statusByDate = /* GraphQL */ `
  query StatusByDate(
    $serial: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelstatusTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    statusByDate(
      serial: $serial
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        cpuTemp
        cpuFreq
        warning
        ramdisk
        signal
        availMem
        pyMem
        gridLength
        nDirect
        nCloud
        freeGB
        lat
        lon
        V
        ovf
        postTime
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLogTable = /* GraphQL */ `
  query GetLogTable($id: ID!) {
    getLogTable(id: $id) {
      id
      serial
      log
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLogTables = /* GraphQL */ `
  query ListLogTables(
    $filter: ModelLogTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        log
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getExceptionTable = /* GraphQL */ `
  query GetExceptionTable($id: ID!) {
    getExceptionTable(id: $id) {
      id
      serial
      exception
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listExceptionTables = /* GraphQL */ `
  query ListExceptionTables(
    $filter: ModelExceptionTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExceptionTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        exception
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const exceptionBySerial = /* GraphQL */ `
  query ExceptionBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModelexceptionTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    exceptionBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        exception
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const exceptionBySerialByDate = /* GraphQL */ `
  query ExceptionBySerialByDate(
    $serial: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelexceptionTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    exceptionBySerialByDate(
      serial: $serial
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        exception
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDailyCount = /* GraphQL */ `
  query GetDailyCount($id: ID!) {
    getDailyCount(id: $id) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDailyCounts = /* GraphQL */ `
  query ListDailyCounts(
    $filter: ModelDailyCountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyCounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        date
        group
        cn
        sn
        spCode
        count
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyCountBySerialByDate = /* GraphQL */ `
  query DailyCountBySerialByDate(
    $serial: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeldailyCountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyCountBySerialByDate(
      serial: $serial
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        date
        group
        cn
        sn
        spCode
        count
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyCountByDate = /* GraphQL */ `
  query DailyCountByDate(
    $date: String!
    $sortDirection: ModelSortDirection
    $filter: ModeldailyCountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyCountByDate(
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        date
        group
        cn
        sn
        spCode
        count
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHourlyCount = /* GraphQL */ `
  query GetHourlyCount($id: ID!) {
    getHourlyCount(id: $id) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHourlyCounts = /* GraphQL */ `
  query ListHourlyCounts(
    $filter: ModelHourlyCountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHourlyCounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        date
        group
        cn
        sn
        spCode
        count
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const itemsBySerialByDate = /* GraphQL */ `
  query ItemsBySerialByDate(
    $serial: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelhourlyCountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsBySerialByDate(
      serial: $serial
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        date
        group
        cn
        sn
        spCode
        count
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLabeledData = /* GraphQL */ `
  query GetLabeledData($id: ID!) {
    getLabeledData(id: $id) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      labeledBy
      label
      score
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLabeledData = /* GraphQL */ `
  query ListLabeledData(
    $filter: ModelLabeledDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLabeledData(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        labeledBy
        label
        score
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const labelBySerialByCn = /* GraphQL */ `
  query LabelBySerialByCn(
    $serial: String!
    $cn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModellabeledDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    labelBySerialByCn(
      serial: $serial
      cn: $cn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        labeledBy
        label
        score
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const labelBySerialByLabel = /* GraphQL */ `
  query LabelBySerialByLabel(
    $serial: String!
    $label: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModellabeledDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    labelBySerialByLabel(
      serial: $serial
      label: $label
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        labeledBy
        label
        score
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const labelByCn = /* GraphQL */ `
  query LabelByCn(
    $cn: String!
    $sortDirection: ModelSortDirection
    $filter: ModellabeledDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    labelByCn(
      cn: $cn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        labeledBy
        label
        score
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const labelByCnByLabel = /* GraphQL */ `
  query LabelByCnByLabel(
    $cn: String!
    $label: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModellabeledDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    labelByCnByLabel(
      cn: $cn
      label: $label
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        group
        cn
        sn
        spCode
        wav
        labeledBy
        label
        score
        lat
        lon
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDailyCountSummary = /* GraphQL */ `
  query GetDailyCountSummary($id: ID!) {
    getDailyCountSummary(id: $id) {
      id
      serial
      countsPerDay
      cn
      spCode
      lat
      lon
      countDate
      wav
      newBirdAlertAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDailyCountSummaries = /* GraphQL */ `
  query ListDailyCountSummaries(
    $filter: ModelDailyCountSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyCountSummaries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        countsPerDay
        cn
        spCode
        lat
        lon
        countDate
        wav
        newBirdAlertAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyCountSummaryBySerialByDate = /* GraphQL */ `
  query DailyCountSummaryBySerialByDate(
    $serial: String!
    $countDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeldailyCountSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyCountSummaryBySerialByDate(
      serial: $serial
      countDate: $countDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        countsPerDay
        cn
        spCode
        lat
        lon
        countDate
        wav
        newBirdAlertAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyCountSummaryBySerialBySpecies = /* GraphQL */ `
  query DailyCountSummaryBySerialBySpecies(
    $serial: String!
    $cn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeldailyCountSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyCountSummaryBySerialBySpecies(
      serial: $serial
      cn: $cn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        countsPerDay
        cn
        spCode
        lat
        lon
        countDate
        wav
        newBirdAlertAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyCountSummaryByDateBySpecies = /* GraphQL */ `
  query DailyCountSummaryByDateBySpecies(
    $countDate: AWSDate!
    $cn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeldailyCountSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyCountSummaryByDateBySpecies(
      countDate: $countDate
      cn: $cn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        countsPerDay
        cn
        spCode
        lat
        lon
        countDate
        wav
        newBirdAlertAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getYearlyCountSummary = /* GraphQL */ `
  query GetYearlyCountSummary($id: ID!) {
    getYearlyCountSummary(id: $id) {
      id
      serial
      countsTotal
      cn
      spCode
      lat
      lon
      countYear
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listYearlyCountSummaries = /* GraphQL */ `
  query ListYearlyCountSummaries(
    $filter: ModelYearlyCountSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listYearlyCountSummaries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        countsTotal
        cn
        spCode
        lat
        lon
        countYear
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const yearlyCountSummaryBySerialByYear = /* GraphQL */ `
  query YearlyCountSummaryBySerialByYear(
    $serial: String!
    $countYear: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelyearlyCountSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    yearlyCountSummaryBySerialByYear(
      serial: $serial
      countYear: $countYear
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        countsTotal
        cn
        spCode
        lat
        lon
        countYear
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserInteraction = /* GraphQL */ `
  query GetUserInteraction($id: ID!) {
    getUserInteraction(id: $id) {
      id
      totalLabeled
      speciesLabeled
      speciesLabeledCode
      totalSpeciesLabeled
      labelStreak
      labelStreakRecord
      dateLastLabeled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserInteractions = /* GraphQL */ `
  query ListUserInteractions(
    $filter: ModelUserInteractionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInteractions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        totalLabeled
        speciesLabeled
        speciesLabeledCode
        totalSpeciesLabeled
        labelStreak
        labelStreakRecord
        dateLastLabeled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getClickTable = /* GraphQL */ `
  query GetClickTable($id: ID!) {
    getClickTable(id: $id) {
      id
      userID
      serial
      spCode
      cn
      clickTarget
      pageClickedFrom
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listClickTables = /* GraphQL */ `
  query ListClickTables(
    $filter: ModelClickTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClickTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        serial
        spCode
        cn
        clickTarget
        pageClickedFrom
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRawHaikumarine = /* GraphQL */ `
  query GetRawHaikumarine($id: ID!) {
    getRawHaikumarine(id: $id) {
      id
      serial
      dt
      lat
      lon
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRawHaikumarines = /* GraphQL */ `
  query ListRawHaikumarines(
    $filter: ModelRawHaikumarineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRawHaikumarines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        dt
        lat
        lon
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const rawHaikumarineBySerialByDate = /* GraphQL */ `
  query RawHaikumarineBySerialByDate(
    $serial: String!
    $dt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelrawHaikumarineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawHaikumarineBySerialByDate(
      serial: $serial
      dt: $dt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        dt
        lat
        lon
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGridByLoc = /* GraphQL */ `
  query GetGridByLoc($id: ID!) {
    getGridByLoc(id: $id) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGridByLocs = /* GraphQL */ `
  query ListGridByLocs(
    $filter: ModelGridByLocFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGridByLocs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lat
        lon
        week
        spCode
        cn
        sn
        gridName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const gridByWeek = /* GraphQL */ `
  query GridByWeek(
    $week: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelgridByLocFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gridByWeek(
      week: $week
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lat
        lon
        week
        spCode
        cn
        sn
        gridName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGridBySpCode = /* GraphQL */ `
  query GetGridBySpCode($id: ID!) {
    getGridBySpCode(id: $id) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGridBySpCodes = /* GraphQL */ `
  query ListGridBySpCodes(
    $filter: ModelGridBySpCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGridBySpCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lat
        lon
        week
        spCode
        cn
        sn
        gridName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGridHistory = /* GraphQL */ `
  query GetGridHistory($id: ID!) {
    getGridHistory(id: $id) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      modType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGridHistories = /* GraphQL */ `
  query ListGridHistories(
    $filter: ModelGridHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGridHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lat
        lon
        week
        spCode
        cn
        sn
        modType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHideBird = /* GraphQL */ `
  query GetHideBird($id: ID!) {
    getHideBird(id: $id) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listHideBirds = /* GraphQL */ `
  query ListHideBirds(
    $filter: ModelHideBirdFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHideBirds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        spCode
        cn
        serial
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hideBirdBySerial = /* GraphQL */ `
  query HideBirdBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModelhideBirdFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hideBirdBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spCode
        cn
        serial
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotifyBird = /* GraphQL */ `
  query GetNotifyBird($id: ID!) {
    getNotifyBird(id: $id) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listNotifyBirds = /* GraphQL */ `
  query ListNotifyBirds(
    $filter: ModelNotifyBirdFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifyBirds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        spCode
        cn
        serial
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notifyBirdBySerial = /* GraphQL */ `
  query NotifyBirdBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModelnotifyBirdFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notifyBirdBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spCode
        cn
        serial
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotifications = /* GraphQL */ `
  query GetNotifications($id: ID!) {
    getNotifications(id: $id) {
      id
      serial
      owner
      played
      notificationType
      cn
      spCode
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        owner
        played
        notificationType
        cn
        spCode
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsBySerial = /* GraphQL */ `
  query NotificationsBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModelnotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        played
        notificationType
        cn
        spCode
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsBySerialByPlayed = /* GraphQL */ `
  query NotificationsBySerialByPlayed(
    $serial: String!
    $played: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelnotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsBySerialByPlayed(
      serial: $serial
      played: $played
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        played
        notificationType
        cn
        spCode
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsBySerialByDate = /* GraphQL */ `
  query NotificationsBySerialByDate(
    $serial: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelnotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsBySerialByDate(
      serial: $serial
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        played
        notificationType
        cn
        spCode
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByOwner = /* GraphQL */ `
  query NotificationsByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelnotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        played
        notificationType
        cn
        spCode
        wav
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOneSignal = /* GraphQL */ `
  query GetOneSignal($id: ID!) {
    getOneSignal(id: $id) {
      id
      playerID
      platform
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listOneSignals = /* GraphQL */ `
  query ListOneSignals(
    $filter: ModelOneSignalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOneSignals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        playerID
        platform
        serial
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const oneSignalBySerial = /* GraphQL */ `
  query OneSignalBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModeloneSignalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    oneSignalBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        playerID
        platform
        serial
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOneSignalConsent = /* GraphQL */ `
  query GetOneSignalConsent($id: ID!) {
    getOneSignalConsent(id: $id) {
      id
      osConsentGranted
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listOneSignalConsents = /* GraphQL */ `
  query ListOneSignalConsents(
    $filter: ModelOneSignalConsentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOneSignalConsents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        osConsentGranted
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShareMap = /* GraphQL */ `
  query GetShareMap($id: ID!) {
    getShareMap(id: $id) {
      id
      name
      shareLat
      shareLon
      tz
      connected
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listShareMaps = /* GraphQL */ `
  query ListShareMaps(
    $filter: ModelShareMapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShareMaps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        shareLat
        shareLon
        tz
        connected
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHaikuboxUser = /* GraphQL */ `
  query GetHaikuboxUser($id: ID!) {
    getHaikuboxUser(id: $id) {
      id
      email
      confirmedEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHaikuboxUsers = /* GraphQL */ `
  query ListHaikuboxUsers(
    $filter: ModelHaikuboxUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHaikuboxUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        confirmedEmail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const haikuboxUserByEmail = /* GraphQL */ `
  query HaikuboxUserByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelhaikuboxUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    haikuboxUserByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        confirmedEmail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBookmarkHaikubox = /* GraphQL */ `
  query GetBookmarkHaikubox($id: ID!) {
    getBookmarkHaikubox(id: $id) {
      id
      serial
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBookmarkHaikuboxes = /* GraphQL */ `
  query ListBookmarkHaikuboxes(
    $filter: ModelBookmarkHaikuboxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookmarkHaikuboxes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bookmarkHaikuboxByOwner = /* GraphQL */ `
  query BookmarkHaikuboxByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelbookmarkHaikuboxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookmarkHaikuboxByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUnclaimHaikubox = /* GraphQL */ `
  query GetUnclaimHaikubox($id: ID!) {
    getUnclaimHaikubox(id: $id) {
      id
      serial
      owner
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUnclaimHaikuboxes = /* GraphQL */ `
  query ListUnclaimHaikuboxes(
    $filter: ModelUnclaimHaikuboxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnclaimHaikuboxes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        email
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unclaimHaikuboxByOwner = /* GraphQL */ `
  query UnclaimHaikuboxByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelunclaimHaikuboxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unclaimHaikuboxByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        email
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserNotice = /* GraphQL */ `
  query GetUserNotice($id: ID!) {
    getUserNotice(id: $id) {
      id
      owner
      noticeID
      noticeViewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserNotices = /* GraphQL */ `
  query ListUserNotices(
    $filter: ModelUserNoticeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        noticeID
        noticeViewed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userNoticeByOwner = /* GraphQL */ `
  query UserNoticeByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModeluserNoticeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userNoticeByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        noticeID
        noticeViewed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userNoticeByOwnerByViewed = /* GraphQL */ `
  query UserNoticeByOwnerByViewed(
    $owner: String!
    $noticeViewed: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeluserNoticeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userNoticeByOwnerByViewed(
      owner: $owner
      noticeViewed: $noticeViewed
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        noticeID
        noticeViewed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNoticeDescription = /* GraphQL */ `
  query GetNoticeDescription($id: ID!) {
    getNoticeDescription(id: $id) {
      id
      noticeTitle
      noticeDescription
      noticeLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNoticeDescriptions = /* GraphQL */ `
  query ListNoticeDescriptions(
    $filter: ModelNoticeDescriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoticeDescriptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        noticeTitle
        noticeDescription
        noticeLink
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeleteAccount = /* GraphQL */ `
  query GetDeleteAccount($id: ID!) {
    getDeleteAccount(id: $id) {
      id
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDeleteAccounts = /* GraphQL */ `
  query ListDeleteAccounts(
    $filter: ModelDeleteAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeleteAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrg = /* GraphQL */ `
  query GetOrg($id: ID!) {
    getOrg(id: $id) {
      id
      owner
      haikuboxName
      lat
      lon
      tz
      publicDirectory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrgs = /* GraphQL */ `
  query ListOrgs(
    $filter: ModelOrgFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrgs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        haikuboxName
        lat
        lon
        tz
        publicDirectory
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orgByPublicDirectory = /* GraphQL */ `
  query OrgByPublicDirectory(
    $publicDirectory: String!
    $sortDirection: ModelSortDirection
    $filter: ModelorgFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orgByPublicDirectory(
      publicDirectory: $publicDirectory
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        haikuboxName
        lat
        lon
        tz
        publicDirectory
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubscription = /* GraphQL */ `
  query GetSubscription($id: ID!) {
    getSubscription(id: $id) {
      id
      owner
      stripeCustomer
      prepaidType
      prepaidPeriodEndUnix
      stripeCurrentPeriodEndUnix
      subscriptionId
      autoRenew
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubscriptions = /* GraphQL */ `
  query ListSubscriptions(
    $filter: ModelSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        stripeCustomer
        prepaidType
        prepaidPeriodEndUnix
        stripeCurrentPeriodEndUnix
        subscriptionId
        autoRenew
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subscriptionByOwner = /* GraphQL */ `
  query SubscriptionByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelsubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        stripeCustomer
        prepaidType
        prepaidPeriodEndUnix
        stripeCurrentPeriodEndUnix
        subscriptionId
        autoRenew
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subscriptionByStripeCustomer = /* GraphQL */ `
  query SubscriptionByStripeCustomer(
    $stripeCustomer: String!
    $sortDirection: ModelSortDirection
    $filter: ModelsubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionByStripeCustomer(
      stripeCustomer: $stripeCustomer
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        stripeCustomer
        prepaidType
        prepaidPeriodEndUnix
        stripeCurrentPeriodEndUnix
        subscriptionId
        autoRenew
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubscriptionHistory = /* GraphQL */ `
  query GetSubscriptionHistory($id: ID!) {
    getSubscriptionHistory(id: $id) {
      id
      owner
      serial
      eventType
      latestInvoice
      stripeCustomer
      subscriptionId
      autoRenew
      datePaidUnix
      unitAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubscriptionHistories = /* GraphQL */ `
  query ListSubscriptionHistories(
    $filter: ModelSubscriptionHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        serial
        eventType
        latestInvoice
        stripeCustomer
        subscriptionId
        autoRenew
        datePaidUnix
        unitAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subscriptionHistoryBySerial = /* GraphQL */ `
  query SubscriptionHistoryBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModelsubscriptionHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionHistoryBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        serial
        eventType
        latestInvoice
        stripeCustomer
        subscriptionId
        autoRenew
        datePaidUnix
        unitAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFavoriteHit = /* GraphQL */ `
  query GetFavoriteHit($id: ID!) {
    getFavoriteHit(id: $id) {
      id
      serial
      owner
      dt
      animalGroup
      cn
      sn
      spCode
      wav
      score
      specSum
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFavoriteHits = /* GraphQL */ `
  query ListFavoriteHits(
    $filter: ModelFavoriteHitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFavoriteHits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        serial
        owner
        dt
        animalGroup
        cn
        sn
        spCode
        wav
        score
        specSum
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const favoriteHitBySerial = /* GraphQL */ `
  query FavoriteHitBySerial(
    $serial: String!
    $sortDirection: ModelSortDirection
    $filter: ModelfavoriteHitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    favoriteHitBySerial(
      serial: $serial
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        dt
        animalGroup
        cn
        sn
        spCode
        wav
        score
        specSum
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const favoriteHitByOwner = /* GraphQL */ `
  query FavoriteHitByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelfavoriteHitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    favoriteHitByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serial
        owner
        dt
        animalGroup
        cn
        sn
        spCode
        wav
        score
        specSum
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserSettings = /* GraphQL */ `
  query GetUserSettings($id: ID!) {
    getUserSettings(id: $id) {
      id
      owner
      hidePics
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserSettings = /* GraphQL */ `
  query ListUserSettings(
    $filter: ModelUserSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        hidePics
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOfflineApi = /* GraphQL */ `
  query GetOfflineApi($id: ID!) {
    getOfflineApi(id: $id) {
      id
      owner
      okey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOfflineApis = /* GraphQL */ `
  query ListOfflineApis(
    $filter: ModelOfflineApiFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOfflineApis(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        okey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTargetFirmware = /* GraphQL */ `
  query GetTargetFirmware($id: ID!) {
    getTargetFirmware(id: $id) {
      id
      owner
      deviceType
      net
      targetVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTargetFirmwares = /* GraphQL */ `
  query ListTargetFirmwares(
    $filter: ModelTargetFirmwareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTargetFirmwares(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        deviceType
        net
        targetVersion
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const stripeUrl = /* GraphQL */ `
  query StripeUrl(
    $serial: String
    $email: String
    $owner: String
    $autoRenew: Boolean
  ) {
    stripeUrl(
      serial: $serial
      email: $email
      owner: $owner
      autoRenew: $autoRenew
    )
  }
`;
export const claimPro = /* GraphQL */ `
  query ClaimPro($serial: String, $ckey: String, $owner: String) {
    claimPro(serial: $serial, ckey: $ckey, owner: $owner)
  }
`;
